"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77549],{

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ createWrapper; },
/* harmony export */   "ju": function() { return /* binding */ HYDRATE; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, { store: this.store },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react__WEBPACK_IMPORTED_MODULE_0__.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 62286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(76489);
var setCookieParser = __webpack_require__(69328);
var utils_1 = __webpack_require__(51022);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51022:
/***/ (function(__unused_webpack_module, exports) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 69328:
/***/ (function(module) {



var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name, // grab everything before the first =
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 88244:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$W": function() { return /* binding */ Channel; }
/* harmony export */ });
/* unused harmony exports StreamChannel, StreamChannel_Scope, StreamChannel_Category, ResearchChannel, ResearchChannel_Scope */
/* harmony import */ var _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7722);
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/base.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.wssocial.entity.message.v1.StreamChannel
 */
const StreamChannel = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.StreamChannel",
  () => [
    { no: 1, name: "scope", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.getEnumType */ .w.getEnumType(StreamChannel_Scope) },
    { no: 2, name: "category", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.getEnumType */ .w.getEnumType(StreamChannel_Category) },
    { no: 3, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.StreamChannel.Scope
 */
const StreamChannel_Scope = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeEnum */ .w.makeEnum(
  "social.wssocial.entity.message.v1.StreamChannel.Scope",
  [
    {no: 0, name: "SCOPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SCOPE_USER", localName: "USER"},
    {no: 2, name: "SCOPE_COMPANY", localName: "COMPANY"},
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.StreamChannel.Category
 */
const StreamChannel_Category = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeEnum */ .w.makeEnum(
  "social.wssocial.entity.message.v1.StreamChannel.Category",
  [
    {no: 0, name: "CATEGORY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CATEGORY_IDEAS", localName: "IDEAS"},
    {no: 2, name: "CATEGORY_REPORTS", localName: "REPORTS"},
    {no: 3, name: "CATEGORY_PREDICTIONS", localName: "PREDICTIONS"},
    {no: 4, name: "CATEGORY_POLLINGS", localName: "POLLINGS"},
    {no: 5, name: "CATEGORY_CHARTS", localName: "CHARTS"},
    {no: 6, name: "CATEGORY_NOTES", localName: "NOTES"},
    {no: 7, name: "CATEGORY_NEWS", localName: "NEWS"},
    {no: 8, name: "CATEGORY_REPLIES", localName: "REPLIES"},
    {no: 9, name: "CATEGORY_LIKED", localName: "LIKED"},
    {no: 10, name: "CATEGORY_SAVED", localName: "SAVED"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ResearchChannel
 */
const ResearchChannel = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.ResearchChannel",
  () => [
    { no: 1, name: "scope", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.getEnumType */ .w.getEnumType(ResearchChannel_Scope) },
    { no: 2, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ResearchChannel.Scope
 */
const ResearchChannel_Scope = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeEnum */ .w.makeEnum(
  "social.wssocial.entity.message.v1.ResearchChannel.Scope",
  [
    {no: 0, name: "SCOPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SCOPE_COMPANY", localName: "COMPANY"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Channel
 */
const Channel = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.Channel",
  () => [
    { no: 1, name: "chatroom", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "roomlist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "streams", kind: "message", T: StreamChannel, repeated: true },
    { no: 4, name: "researches", kind: "message", T: ResearchChannel, repeated: true },
  ],
);



/***/ }),

/***/ 45621:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gn": function() { return /* binding */ received_pb_ReceivedMessage; }
});

// UNUSED EXPORTS: Body, Error, Ping, Ping_PingStatus, ReceivedEvent, ReceivedEvent_Data, ReceivedEvent_Type, ReceivedMessage_Type, Subscription, Subscription_Status

// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/message/v1/base_pb.js
var base_pb = __webpack_require__(88244);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/text_mask_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/text_mask.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.chat.entity.v2.TextFormat
 */
const TextFormat = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.TextFormat",
  [
    {no: 0, name: "TEXT_FORMAT_REGULAR", localName: "REGULAR"},
    {no: 1, name: "TEXT_FORMAT_BOLD", localName: "BOLD"},
    {no: 2, name: "TEXT_FORMAT_ITALIC", localName: "ITALIC"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MaskedText
 */
const MaskedText = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MaskedText",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TextMaskValue} },
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextMaskValue
 */
const TextMaskValue = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.TextMaskValue",
  () => [
    { no: 1, name: "format", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(TextFormat) },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "link", kind: "message", T: TextLink },
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextLink
 */
const TextLink = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.TextLink",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(TextLink_LinkType) },
    { no: 2, name: "ref", kind: "message", T: TextLink_LinkRef },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.TextLink.LinkType
 */
const TextLink_LinkType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.TextLink.LinkType",
  [
    {no: 0, name: "LINK_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LINK_TYPE_USER", localName: "USER"},
    {no: 2, name: "LINK_TYPE_SYMBOL", localName: "SYMBOL"},
    {no: 3, name: "LINK_TYPE_KNOWN_URL", localName: "KNOWN_URL"},
    {no: 4, name: "LINK_TYPE_URL", localName: "URL"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextLink.LinkRef
 */
const TextLink_LinkRef = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.TextLink.LinkRef",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
  ],
  {localName: "TextLink_LinkRef"},
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMaskedText
 */
const PlaceholderMaskedText = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PlaceholderMaskedText",
  () => [
    { no: 1, name: "masked_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: PlaceholderMask} },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMask
 */
const PlaceholderMask = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PlaceholderMask",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PlaceholderMask_PlaceholderType) },
    { no: 2, name: "placeholder", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reference", kind: "message", T: PlaceholderMask_Reference },
  ],
);

/**
 * used to determine "username" and "to be" based on the user's point of view
 * First person point of view example: "You are an admin now"
 * Third person point of view example: "StockbitUser is an admin now"
 *
 * @generated from enum social.chat.entity.v2.PlaceholderMask.PlaceholderType
 */
const PlaceholderMask_PlaceholderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.PlaceholderMask.PlaceholderType",
  [
    {no: 0, name: "PLACEHOLDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLACEHOLDER_TYPE_USERNAME", localName: "USERNAME"},
    {no: 2, name: "PLACEHOLDER_TYPE_TO_BE", localName: "TO_BE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMask.Reference
 */
const PlaceholderMask_Reference = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PlaceholderMask.Reference",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "PlaceholderMask_Reference"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/verified_badge/enum/v1/verified_status_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/verified_badge/enum/v1/verified_status.proto (package social.verified_badge.enum.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.verified_badge.enum.v1.VerifiedStatus
 */
const verified_status_pb_VerifiedStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.verified_badge.enum.v1.VerifiedStatus",
  [
    {no: 0, name: "VERIFIED_STATUS_UNVERIFIED", localName: "UNVERIFIED"},
    {no: 1, name: "VERIFIED_STATUS_IDENTITY", localName: "IDENTITY"},
    {no: 2, name: "VERIFIED_STATUS_COMMUNITY", localName: "COMMUNITY"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/room_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/room.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from enum social.chat.entity.v2.RoomType
 */
const RoomType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.RoomType",
  [
    {no: 0, name: "ROOM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ROOM_TYPE_PERSONAL", localName: "PERSONAL"},
    {no: 2, name: "ROOM_TYPE_GROUP", localName: "GROUP"},
    {no: 3, name: "ROOM_TYPE_BROADCAST", localName: "BROADCAST"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.RoomState
 */
const room_pb_RoomState = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.RoomState",
  [
    {no: 0, name: "ROOM_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ROOM_STATE_ACCEPTED", localName: "ACCEPTED"},
    {no: 2, name: "ROOM_STATE_INVITED", localName: "INVITED"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomInfo
 */
const RoomInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.RoomInfo",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shortened_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.BaseRoom
 */
const BaseRoom = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.BaseRoom",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(RoomType) },
    { no: 3, name: "info", kind: "message", T: RoomInfo },
    { no: 4, name: "state", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(room_pb_RoomState) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.Room
 */
const Room = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.Room",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(RoomType) },
    { no: 3, name: "info", kind: "message", T: RoomInfo },
    { no: 4, name: "attributes", kind: "message", T: RoomAttribute },
    { no: 5, name: "unread_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "last_message", kind: "message", T: LastMessage },
    { no: 7, name: "status", kind: "message", T: RoomStatus },
    { no: 8, name: "state", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(room_pb_RoomState) },
    { no: 9, name: "unread_message", kind: "message", T: UnreadMessage },
    { no: 10, name: "sharetrade", kind: "message", T: RoomShareTrade },
  ],
);

/**
 * @generated from message social.chat.entity.v2.UnreadMessage
 */
const UnreadMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.UnreadMessage",
  () => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "last_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.LastMessage
 */
const LastMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.LastMessage",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sender_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(LastMessage_AttachmentType) },
    { no: 4, name: "created_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 5, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "placeholder_mask", kind: "message", T: PlaceholderMaskedText },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.LastMessage.AttachmentType
 */
const LastMessage_AttachmentType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.LastMessage.AttachmentType",
  [
    {no: 0, name: "ATTACHMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ATTACHMENT_TYPE_PHOTO", localName: "PHOTO"},
    {no: 2, name: "ATTACHMENT_TYPE_GIF", localName: "GIF"},
    {no: 3, name: "ATTACHMENT_TYPE_POST", localName: "POST"},
    {no: 4, name: "ATTACHMENT_TYPE_SHARETRADE", localName: "SHARETRADE"},
    {no: 5, name: "ATTACHMENT_TYPE_PDF", localName: "PDF"},
    {no: 6, name: "ATTACHMENT_TYPE_STICKER", localName: "STICKER"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomStatus
 */
const RoomStatus = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.RoomStatus",
  () => [
    { no: 1, name: "is_muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_mentioned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomAttribute
 */
const RoomAttribute = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.RoomAttribute",
  () => [
    { no: 1, name: "personal", kind: "message", T: PersonalRoomAttribute, oneof: "attr" },
    { no: 2, name: "group", kind: "message", T: GroupRoomAttribute, oneof: "attr" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PersonalRoomAttribute
 */
const PersonalRoomAttribute = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PersonalRoomAttribute",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_deactivated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_blocked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "verified_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(verified_status_pb_VerifiedStatus) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.GroupRoomAttribute
 */
const GroupRoomAttribute = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.GroupRoomAttribute",
  () => [
    { no: 1, name: "member_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomShareTrade
 */
const RoomShareTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.RoomShareTrade",
  () => [
    { no: 1, name: "is_autoshare_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_share_value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/data/v1/comment_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/data/v1/comment.proto (package social.stream.data.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.stream.data.v1.CommenterType
 */
const comment_pb_CommenterType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.data.v1.CommenterType",
  [
    {no: 0, name: "COMMENTER_TYPE_EVERYONE", localName: "EVERYONE"},
    {no: 1, name: "COMMENTER_TYPE_FOLLOWING", localName: "FOLLOWING"},
    {no: 2, name: "COMMENTER_TYPE_MENTION", localName: "MENTION"},
    {no: 3, name: "COMMENTER_TYPE_ONLY_YOU", localName: "ONLY_YOU"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/data/v1/image_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/data/v1/image.proto (package social.stream.data.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.stream.data.v1.FrameType
 */
const image_pb_FrameType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.data.v1.FrameType",
  [
    {no: 0, name: "FRAME_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FRAME_TYPE_SQUARE", localName: "SQUARE"},
    {no: 2, name: "FRAME_TYPE_PORTRAIT", localName: "PORTRAIT"},
    {no: 3, name: "FRAME_TYPE_LANDSCAPE", localName: "LANDSCAPE"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/data/v1/spam_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/data/v1/spam.proto (package social.stream.data.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.stream.data.v1.SpamStatus
 */
const spam_pb_SpamStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.data.v1.SpamStatus",
  [
    {no: 0, name: "SPAM_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SPAM_STATUS_DETECTED", localName: "DETECTED"},
    {no: 2, name: "SPAM_STATUS_DELETED", localName: "DELETED"},
    {no: 3, name: "SPAM_STATUS_NOT_SPAM", localName: "NOT_SPAM"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/entity/v1/entity_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/entity/v1/entity.proto (package social.stream.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from message social.stream.entity.v1.Polling
 */
const Polling = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Polling",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "created_date", jsonName: "created_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", jsonName: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "end_date", jsonName: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "options", kind: "message", T: PollingOptions, repeated: true },
    { no: 8, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "message_expired", jsonName: "message_expired", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "total_voters", jsonName: "total_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "my_vote", jsonName: "my_vote", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.ImageData
 */
const ImageData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.ImageData",
  () => [
    { no: 1, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "frame", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "frame_type", jsonName: "frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.PollingOptions
 */
const PollingOptions = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.PollingOptions",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count_voters", jsonName: "count_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.TargetPrice
 */
const TargetPrice = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.TargetPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "voted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "current_price", jsonName: "current_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "day_left", jsonName: "day_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "agree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "disagree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "hit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.MaskHtml
 */
const MaskHtml = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.MaskHtml",
  () => [
    { no: 1, name: "mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attr", kind: "message", T: MaskAttr },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.MaskAttr
 */
const MaskAttr = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.MaskAttr",
  () => [
    { no: 1, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data_company", jsonName: "data_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_user", jsonName: "data_user", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data_insider", jsonName: "data_insider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.ReplyContent
 */
const ReplyContent = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.ReplyContent",
  () => [
    { no: 1, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 14, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 15, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Analytics
 */
const Analytics = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Analytics",
  () => [
    { no: 1, name: "impression", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "engagement", kind: "message", T: AnalyticsEngagement },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.AnalyticsEngagement
 */
const AnalyticsEngagement = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.AnalyticsEngagement",
  () => [
    { no: 1, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "reply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "share", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "profile_view", jsonName: "profile_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sign_click", jsonName: "sign_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "media_click", jsonName: "media_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Reports
 */
const Reports = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Reports",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Stream
 */
const Stream = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Stream",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "message", T: Timestamp },
    { no: 7, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 8, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 9, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 10, name: "attachments", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "parent_id", jsonName: "parent_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "user", kind: "message", T: User },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.User
 */
const User = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.User",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.ReplyInfo
 */
const entity_pb_ReplyInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.ReplyInfo",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message social.stream.entity.v1.SpamStream
 */
const SpamStream = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.SpamStream",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "post_url", jsonName: "post_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", jsonName: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(SpamStatus) },
    { no: 5, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "user", kind: "message", T: User },
    { no: 7, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 8, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Pagination
 */
const Pagination = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Pagination",
  () => [
    { no: 1, name: "current_page", jsonName: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_data_in_page", jsonName: "total_data_in_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_data", jsonName: "total_data", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Liker
 */
const entity_pb_Liker = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Liker",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "followed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.FollowingActivity
 */
const entity_pb_FollowingActivity = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.FollowingActivity",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.News
 */
const News = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.News",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source_url", jsonName: "source_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", jsonName: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Research
 */
const Research = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Research",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_label", jsonName: "category_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image_url", jsonName: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", jsonName: "created_at", kind: "message", T: Timestamp },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Insider
 */
const Insider = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Insider",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shareholder", kind: "message", T: Insider_Shareholder },
    { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(Insider_Type) },
    { no: 5, name: "action", kind: "enum", T: proto3.getEnumType(Insider_Action) },
    { no: 6, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "current", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "corp_action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from enum social.stream.entity.v1.Insider.Type
 */
const Insider_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.Insider.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_LOCAL", localName: "LOCAL"},
    {no: 2, name: "TYPE_FOREIGN", localName: "FOREIGN"},
  ],
);

/**
 * @generated from enum social.stream.entity.v1.Insider.Action
 */
const Insider_Action = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.Insider.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_BOUGHT", localName: "BOUGHT"},
    {no: 2, name: "ACTION_SOLD", localName: "SOLD"},
  ],
);

/**
 * @generated from message social.stream.entity.v1.Insider.Shareholder
 */
const Insider_Shareholder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.Insider.Shareholder",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "Insider_Shareholder"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/entity/v1/sharetrade_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/entity/v1/sharetrade.proto (package social.stream.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.stream.entity.v1.ShareTradeInfo
 */
const sharetrade_pb_ShareTradeInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.ShareTradeInfo",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_type", jsonName: "order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_OrderType) },
    { no: 4, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "pnl", kind: "message", T: ShareTradeInfo_PNL },
  ],
);

/**
 * @generated from enum social.stream.entity.v1.ShareTradeInfo.OrderType
 */
const ShareTradeInfo_OrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.ShareTradeInfo.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_BUY", localName: "BUY"},
    {no: 2, name: "ORDER_TYPE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from message social.stream.entity.v1.ShareTradeInfo.PNL
 */
const ShareTradeInfo_PNL = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.ShareTradeInfo.PNL",
  () => [
    { no: 1, name: "percentage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_PNL_Type) },
  ],
  {localName: "ShareTradeInfo_PNL"},
);

/**
 * @generated from enum social.stream.entity.v1.ShareTradeInfo.PNL.Type
 */
const ShareTradeInfo_PNL_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.ShareTradeInfo.PNL.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_GAIN", localName: "GAIN"},
    {no: 2, name: "TYPE_LOSS", localName: "LOSS"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/v1/stream_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/v1/stream.proto (package social.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck








/**
 * @generated from message social.stream.v1.GetUploadTokenRequest
 */
const GetUploadTokenRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenRequest",
  () => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenResponse
 */
const GetUploadTokenResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: DataUploadTokenResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.DataUploadTokenResponse
 */
const DataUploadTokenResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DataUploadTokenResponse",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "aws_access_key_id", jsonName: "aws_access_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "success_action_redirect", jsonName: "success_action_redirect", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "policy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokensRequest
 */
const GetUploadTokensRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokensRequest",
  () => [
    { no: 1, name: "filenames", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokensResponse
 */
const GetUploadTokensResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokensResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetUploadTokenData },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenData
 */
const GetUploadTokenData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenData",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tokens", kind: "message", T: GetUploadTokenInfo, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenInfo
 */
const GetUploadTokenInfo = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenInfo",
  () => [
    { no: 1, name: "fields", kind: "message", T: GetUploadTokenInfo_Fields, repeated: true },
    { no: 2, name: "view_url", jsonName: "view_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenInfo.Fields
 */
const GetUploadTokenInfo_Fields = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.GetUploadTokenInfo.Fields",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "GetUploadTokenInfo_Fields"},
);

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessRequest
 */
const ProcessUploadSuccessRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessRequest",
  () => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessResponse
 */
const ProcessUploadSuccessResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: ProcessUploadSuccessData },
  ],
)));

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessData
 */
const ProcessUploadSuccessData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessData",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url_bit", jsonName: "url_bit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.WriteStreamRequest
 */
const WriteStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.WriteStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "target_symbol", jsonName: "target_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "target_duration", jsonName: "target_duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "polling_end", jsonName: "polling_end", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "polling_options", jsonName: "polling_options", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "polling_pin", jsonName: "polling_pin", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "share_portfolio", jsonName: "share_portfolio", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.WriteStreamResponse
 */
const WriteStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.WriteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.ReplyStreamResponse
 */
const ReplyStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReplyStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveNewsStreamResponse
 */
const SaveNewsStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveNewsStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveInsiderStreamResponse
 */
const SaveInsiderStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveInsiderStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveEmitenReportStreamResponse
 */
const SaveEmitenReportStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveEmitenReportStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateStreamResponse
 */
const UpdateStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.LikeStreamResponse
 */
const LikeStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.LikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UnlikeStreamResponse
 */
const UnlikeStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnlikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.DislikeStreamResponse
 */
const DislikeStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DislikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveStreamResponse
 */
const SaveStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UnsaveStreamResponse
 */
const UnsaveStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnsaveStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.ReportStreamResponse
 */
const ReportStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReportStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.FollowStreamResponse
 */
const FollowStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.FollowStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UnfollowStreamResponse
 */
const UnfollowStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnfollowStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.PinStreamResponse
 */
const PinStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.PinStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.UnpinStreamResponse
 */
const UnpinStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnpinStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.ShareStreamResponse
 */
const ShareStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ShareStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.PostStreamResponse
 */
const PostStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.PostStreamResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "lastid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 26, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "shorten_url", jsonName: "shorten_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: stream_pb_Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "replyto", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "reply_content", jsonName: "reply_content", kind: "message", T: stream_pb_ReplyContent },
    { no: 42, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "target_price", jsonName: "target_price", kind: "message", T: stream_pb_TargetPrice, repeated: true },
    { no: 45, name: "analytics", kind: "message", T: stream_pb_Analytics },
    { no: 46, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 47, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 49, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 50, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 51, name: "polling", kind: "message", T: stream_pb_Polling, repeated: true },
    { no: 52, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 53, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 54, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 55, name: "replying_to", jsonName: "replying_to", kind: "message", T: ReplyInfo },
    { no: 56, name: "verified_status", jsonName: "verified_status", kind: "enum", T: proto3.getEnumType(VerifiedStatus) },
  ],
)));

/**
 * @generated from message social.stream.v1.Polling
 */
const stream_pb_Polling = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.Polling",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "created_date", jsonName: "created_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", jsonName: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "end_date", jsonName: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "options", kind: "message", T: stream_pb_PollingOptions, repeated: true },
    { no: 8, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "message_expired", jsonName: "message_expired", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "total_voters", jsonName: "total_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "my_vote", jsonName: "my_vote", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.ImagesData
 */
const ImagesData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.ImagesData",
  () => [
    { no: 1, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "frame", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "frame_type", jsonName: "frame_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(image_pb_FrameType) },
  ],
);

/**
 * @generated from message social.stream.v1.PollingOptions
 */
const stream_pb_PollingOptions = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.PollingOptions",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count_voters", jsonName: "count_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.TargetPrice
 */
const stream_pb_TargetPrice = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.TargetPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "voted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "current_price", jsonName: "current_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "day_left", jsonName: "day_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "agree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "disagree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "hit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.MaskHtml
 */
const stream_pb_MaskHtml = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.MaskHtml",
  () => [
    { no: 1, name: "mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attr", kind: "message", T: stream_pb_MaskAttr },
  ],
);

/**
 * @generated from message social.stream.v1.MaskAttr
 */
const stream_pb_MaskAttr = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.MaskAttr",
  () => [
    { no: 1, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data_company", jsonName: "data_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_user", jsonName: "data_user", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data_insider", jsonName: "data_insider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ReplyContent
 */
const stream_pb_ReplyContent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.ReplyContent",
  () => [
    { no: 1, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 14, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 15, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(image_pb_FrameType) },
  ],
);

/**
 * @generated from message social.stream.v1.Analytics
 */
const stream_pb_Analytics = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.Analytics",
  () => [
    { no: 1, name: "impression", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "engagement", kind: "message", T: stream_pb_AnalyticsEngagement },
  ],
);

/**
 * @generated from message social.stream.v1.AnalyticsEngagement
 */
const stream_pb_AnalyticsEngagement = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.AnalyticsEngagement",
  () => [
    { no: 1, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "reply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "share", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "profile_view", jsonName: "profile_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sign_click", jsonName: "sign_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "media_click", jsonName: "media_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.Reports
 */
const stream_pb_Reports = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.Reports",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ReplyStreamRequest
 */
const ReplyStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReplyStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "replyto", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveNewsStreamRequest
 */
const SaveNewsStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveNewsStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveEmitenReportStreamRequest
 */
const SaveEmitenReportStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveEmitenReportStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveInsiderStreamRequest
 */
const SaveInsiderStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveInsiderStreamRequest",
  () => [
    { no: 1, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 2, name: "content_mask", jsonName: "content_mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateStreamRequest
 */
const UpdateStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_symbol", jsonName: "target_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "target_duration", jsonName: "target_duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.LikeStreamRequest
 */
const LikeStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.LikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnlikeStreamRequest
 */
const UnlikeStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnlikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DislikeStreamRequest
 */
const DislikeStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DislikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveStreamRequest
 */
const SaveStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnsaveStreamRequest
 */
const UnsaveStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnsaveStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.PinStreamRequest
 */
const PinStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.PinStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnpinStreamRequest
 */
const UnpinStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnpinStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.ShareStreamRequest
 */
const ShareStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ShareStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "facebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "twitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "stockbit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.ReportStreamRequest
 */
const ReportStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReportStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.FollowStreamRequest
 */
const FollowStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.FollowStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnfollowStreamRequest
 */
const UnfollowStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnfollowStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateCommenterTypeRequest
 */
const UpdateCommenterTypeRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateCommenterTypeRequest",
  () => [
    { no: 1, name: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateCommenterTypeResponse
 */
const UpdateCommenterTypeResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateCommenterTypeResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamRequest
 * @deprecated
 */
const DeleteStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "send_email", jsonName: "send_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamResponse
 * @deprecated
 */
const DeleteStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamsRequest
 */
const DeleteStreamsRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamsRequest",
  () => [
    { no: 1, name: "user_id", jsonName: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "send_email", jsonName: "send_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamsResponse
 */
const DeleteStreamsResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamsResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UndeleteStreamRequest
 */
const UndeleteStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UndeleteStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UndeleteStreamResponse
 */
const UndeleteStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UndeleteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnStreamRequest
 */
const DeleteOwnStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnStreamRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnStreamResponse
 */
const DeleteOwnStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnCommentRequest
 */
const DeleteOwnCommentRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnCommentRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnCommentResponse
 */
const DeleteOwnCommentResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnCommentResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.AddVoteRequest
 */
const AddVoteRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.AddVoteRequest",
  () => [
    { no: 1, name: "tp_id", jsonName: "tp_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "agree", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.AddVoteResponse
 */
const AddVoteResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.AddVoteResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.ManipulateStreamRequest
 */
const ManipulateStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ManipulateStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "dislike", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.ManipulateStreamResponse
 */
const ManipulateStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ManipulateStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetGenericStreamRequest
 */
const GetGenericStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetGenericStreamRequest",
  () => [
    { no: 1, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "beforetimestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "reporttype", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUserStreamRequest
 */
const GetUserStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUserStreamRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSymbolStreamRequest
 */
const GetSymbolStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSymbolStreamRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "beforelastpost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "reporttype", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetGenericStreamResponse
 */
const GetGenericStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetGenericStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSymbolStreamResponse
 */
const GetSymbolStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSymbolStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetStreamResponse
 */
const GetStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetStreamResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 25, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "polling", kind: "message", T: stream_pb_Polling, repeated: true },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: stream_pb_Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "total_view", jsonName: "total_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 40, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "target_price", jsonName: "target_price", kind: "message", T: stream_pb_TargetPrice, repeated: true },
    { no: 43, name: "analytics", kind: "message", T: stream_pb_Analytics },
    { no: 44, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "last_reply_date", jsonName: "last_reply_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 46, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 47, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 49, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 50, name: "last_reply", jsonName: "last_reply", kind: "message", T: GetStreamResponse },
    { no: 51, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 52, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 53, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 54, name: "replying_to", jsonName: "replying_to", kind: "message", T: ReplyInfo },
    { no: 55, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
    { no: 56, name: "following_activity", jsonName: "following_activity", kind: "message", T: FollowingActivity },
    { no: 57, name: "sharetrade_info", jsonName: "sharetrade_info", kind: "message", T: ShareTradeInfo },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUserStreamResponse
 */
const GetUserStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUserStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetTrendingStreamResponse
 */
const GetTrendingStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetTrendingStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetStreamOldResponse
 */
const GetStreamOldResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.GetStreamOldResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 26, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "polling", kind: "message", T: stream_pb_Polling, repeated: true },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: stream_pb_Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "total_view", jsonName: "total_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 40, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "replyto", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "reply_content", jsonName: "reply_content", kind: "message", T: stream_pb_ReplyContent },
    { no: 43, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "target_price", jsonName: "target_price", kind: "message", T: stream_pb_TargetPrice, repeated: true },
    { no: 46, name: "analytics", kind: "message", T: stream_pb_Analytics },
    { no: 47, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 49, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 50, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 51, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 52, name: "is_verified", jsonName: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 53, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 54, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(image_pb_FrameType) },
    { no: 55, name: "replying_to", jsonName: "replying_to", kind: "message", T: entity_pb_ReplyInfo },
    { no: 56, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(comment_pb_CommenterType) },
    { no: 57, name: "is_unavailable", jsonName: "is_unavailable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 58, name: "following_activity", jsonName: "following_activity", kind: "message", T: entity_pb_FollowingActivity },
    { no: 59, name: "sharetrade_info", jsonName: "sharetrade_info", kind: "message", T: sharetrade_pb_ShareTradeInfo },
    { no: 60, name: "verified_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(verified_status_pb_VerifiedStatus) },
  ],
);

/**
 * @generated from message social.stream.v1.GetSentimentCompanyNewsRequest
 */
const GetSentimentCompanyNewsRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSentimentCompanyNewsRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSentimentCompanyNewsResponse
 */
const GetSentimentCompanyNewsResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSentimentCompanyNewsResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: Sentiment },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.Sentiment
 */
const Sentiment = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.Sentiment",
  () => [
    { no: 1, name: "start_value", jsonName: "start_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_value", jsonName: "end_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "periode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetConversationStreamRequest
 */
const GetConversationStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamRequest",
  () => [
    { no: 1, name: "convo_parentid", jsonName: "convo_parentid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "streamid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetConversationStreamResponse
 */
const GetConversationStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetConversationStreamModel },
  ],
)));

/**
 * @generated from message social.stream.v1.GetConversationStreamModel
 */
const GetConversationStreamModel = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamModel",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "next", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "prev", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "parent", kind: "message", T: GetStreamOldResponse },
    { no: 5, name: "replies", kind: "message", T: GetStreamOldResponse, repeated: true },
    { no: 6, name: "since_message", jsonName: "since_message", kind: "message", T: SinceMessage, repeated: true },
    { no: 7, name: "total_replies", jsonName: "total_replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
    { no: 9, name: "is_commentable", jsonName: "is_commentable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SinceMessage
 */
const SinceMessage = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SinceMessage",
  () => [
    { no: 1, name: "streamid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "change", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "pchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "company_name", jsonName: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "latest", kind: "message", T: IfeedPrice },
  ],
)));

/**
 * @generated from message social.stream.v1.IfeedPrice
 */
const IfeedPrice = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.IfeedPrice",
  () => [
    { no: 1, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastprice", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "volume", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "avgvolume", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamRequest
 */
const GetMoreConversationStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamResponse
 */
const GetMoreConversationStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetMoreConversationStreamModel },
  ],
)));

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamModel
 */
const GetMoreConversationStreamModel = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamModel",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "replies", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetTrendingStreamRequest
 */
const GetTrendingStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetTrendingStreamRequest",
  () => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamUserRequest
 */
const GetPinnedStreamUserRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamUserRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamUserResponse
 */
const GetPinnedStreamUserResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamUserResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamCompanyRequest
 */
const GetPinnedStreamCompanyRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamCompanyRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamCompanyResponse
 */
const GetPinnedStreamCompanyResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamCompanyResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSingleStreamPostRequest
 */
const GetSingleStreamPostRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSingleStreamPostRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSingleStreamPostResponse
 */
const GetSingleStreamPostResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSingleStreamPostResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.GetLikersRequest
 */
const GetLikersRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetLikersRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetLikersResponse
 */
const GetLikersResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetLikersResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetLikersData },
  ],
)));

/**
 * @generated from message social.stream.v1.GetLikersData
 */
const GetLikersData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetLikersData",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "likers", kind: "message", T: Liker, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetAnnouncementRequest
 */
const GetAnnouncementRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementRequest",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetAnnouncementResponse
 */
const GetAnnouncementResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetAnnouncementData, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetAnnouncementData
 */
const GetAnnouncementData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementData",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "posted_on", jsonName: "posted_on", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "headline", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "retrieved_on", jsonName: "retrieved_on", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "company_icon_url", jsonName: "company_icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UntagTopicRequest
 */
const UntagTopicRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UntagTopicRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UntagTopicResponse
 */
const UntagTopicResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UntagTopicResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/message_content_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/message_content.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from enum social.chat.entity.v2.SharedContentType
 */
const SharedContentType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.SharedContentType",
  [
    {no: 0, name: "SHARED_CONTENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SHARED_CONTENT_TYPE_STREAM", localName: "STREAM"},
    {no: 2, name: "SHARED_CONTENT_TYPE_GROUP_INVITATION", localName: "GROUP_INVITATION"},
    {no: 3, name: "SHARED_CONTENT_TYPE_SHARETRADE", localName: "SHARETRADE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.Attachment
 */
const Attachment = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.Attachment",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "size", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentInternal
 */
const SharedContentInternal = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentInternal",
  () => [
    { no: 1, name: "source_type", kind: "enum", T: proto3.getEnumType(SharedContentInternal_SourceType) },
    { no: 2, name: "source_data", kind: "message", T: SharedContentInternal_SourceData },
  ],
)));

/**
 * @generated from enum social.chat.entity.v2.SharedContentInternal.SourceType
 */
const SharedContentInternal_SourceType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.SharedContentInternal.SourceType",
  [
    {no: 0, name: "SOURCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SOURCE_TYPE_REFERENCE", localName: "REFERENCE"},
    {no: 2, name: "SOURCE_TYPE_PAYLOAD", localName: "PAYLOAD"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentInternal.SourceData
 */
const SharedContentInternal_SourceData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentInternal.SourceData",
  () => [
    { no: 1, name: "reference", kind: "message", T: SharedContent, oneof: "source" },
    { no: 2, name: "payload", kind: "message", T: SharedContentPayload, oneof: "source" },
  ],
  {localName: "SharedContentInternal_SourceData"},
);

/**
 * @generated from message social.chat.entity.v2.SharedContent
 */
const SharedContent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContent",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SharedContentType) },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPayload
 */
const SharedContentPayload = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPayload",
  () => [
    { no: 1, name: "payload", kind: "message", T: SharedContentPayload_Payload },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.SharedContentPayload.Type
 */
const SharedContentPayload_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.SharedContentPayload.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_SHARETRADE", localName: "SHARETRADE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPayload.Payload
 */
const SharedContentPayload_Payload = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPayload.Payload",
  () => [
    { no: 1, name: "sharetrade", kind: "message", T: message_content_pb_ShareTradeInfo, oneof: "data" },
  ],
  {localName: "SharedContentPayload_Payload"},
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPreview
 */
const SharedContentPreview = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPreview",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SharedContentType) },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "preview", kind: "message", T: SharedContentPreview_Preview },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPreview.Preview
 */
const SharedContentPreview_Preview = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPreview.Preview",
  () => [
    { no: 1, name: "stream", kind: "message", T: GetStreamOldResponse, oneof: "data" },
    { no: 2, name: "invitation", kind: "message", T: InvitationContentPreview, oneof: "data" },
    { no: 3, name: "sharetrade", kind: "message", T: message_content_pb_ShareTradeInfo, oneof: "data" },
  ],
  {localName: "SharedContentPreview_Preview"},
);

/**
 * @generated from message social.chat.entity.v2.InvitationContentPreview
 */
const InvitationContentPreview = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.InvitationContentPreview",
  () => [
    { no: 1, name: "invitation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "room_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.ShareTradeInfo
 */
const message_content_pb_ShareTradeInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.ShareTradeInfo",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(message_content_pb_ShareTradeInfo_OrderType) },
    { no: 4, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_OrderStatus) },
    { no: 5, name: "updated_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_UpdatedStatus) },
    { no: 6, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "updated_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "order_time", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 10, name: "label", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_Label) },
    { no: 11, name: "is_show_value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "qty", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "updated_qty", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "total_investment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "is_amend_lot", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.OrderType
 */
const message_content_pb_ShareTradeInfo_OrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_BUY", localName: "BUY"},
    {no: 2, name: "ORDER_TYPE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.OrderStatus
 */
const ShareTradeInfo_OrderStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.OrderStatus",
  [
    {no: 0, name: "ORDER_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "ORDER_STATUS_AMEND", localName: "AMEND"},
    {no: 3, name: "ORDER_STATUS_CANCEL", localName: "CANCEL"},
    {no: 4, name: "ORDER_STATUS_MATCH", localName: "MATCH"},
    {no: 5, name: "ORDER_STATUS_PARTIAL_MATCH", localName: "PARTIAL_MATCH"},
    {no: 6, name: "ORDER_STATUS_PENDING", localName: "PENDING"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.UpdatedStatus
 */
const ShareTradeInfo_UpdatedStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.UpdatedStatus",
  [
    {no: 0, name: "UPDATED_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UPDATED_STATUS_AMENDED", localName: "AMENDED"},
    {no: 2, name: "UPDATED_STATUS_CANCELLED", localName: "CANCELLED"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.Label
 */
const ShareTradeInfo_Label = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.Label",
  [
    {no: 0, name: "LABEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LABEL_DAY_TRADE", localName: "DAY_TRADE"},
    {no: 2, name: "LABEL_SPLIT_ORDER", localName: "SPLIT_ORDER"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/attachment_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/attachment.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from enum social.chat.entity.v2.UploadType
 */
const UploadType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.UploadType",
  [
    {no: 0, name: "UPLOAD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UPLOAD_TYPE_PICTURE", localName: "PICTURE"},
    {no: 2, name: "UPLOAD_TYPE_DOCUMENT", localName: "DOCUMENT"},
    {no: 3, name: "UPLOAD_TYPE_STICKER", localName: "STICKER"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.AttachmentType
 */
const AttachmentType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.AttachmentType",
  [
    {no: 0, name: "ATTACHMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ATTACHMENT_TYPE_UPLOADED", localName: "UPLOADED"},
    {no: 2, name: "ATTACHMENT_TYPE_SHARED", localName: "SHARED"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.AttachmentMeta
 */
const AttachmentMeta = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.AttachmentMeta",
  () => [
    { no: 1, name: "picture", kind: "message", T: PictureMeta, oneof: "meta" },
    { no: 2, name: "document", kind: "message", T: DocumentMeta, oneof: "meta" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PictureMeta
 */
const PictureMeta = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PictureMeta",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * reserve for later
 *
 * @generated from message social.chat.entity.v2.DocumentMeta
 */
const DocumentMeta = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.DocumentMeta",
  [],
);

/**
 * @generated from message social.chat.entity.v2.UploadAttachment
 */
const UploadAttachment = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.UploadAttachment",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(UploadType) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "meta", kind: "message", T: AttachmentMeta },
  ],
);

/**
 * @generated from message social.chat.entity.v2.AttachmentV2
 */
const AttachmentV2 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.AttachmentV2",
  () => [
    { no: 1, name: "upload", kind: "message", T: UploadAttachment, oneof: "attachment" },
    { no: 2, name: "shared", kind: "message", T: SharedContentPreview, oneof: "attachment" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.UploadAttachmentParam
 */
const UploadAttachmentParam = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.UploadAttachmentParam",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(UploadType) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/member_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/member.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from enum social.chat.entity.v2.MemberRole
 */
const MemberRole = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MemberRole",
  [
    {no: 0, name: "MEMBER_ROLE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MEMBER_ROLE_NORMAL", localName: "NORMAL"},
    {no: 2, name: "MEMBER_ROLE_ADMIN", localName: "ADMIN"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MemberUser
 */
const MemberUser = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MemberUser",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "member_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "verified_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(verified_status_pb_VerifiedStatus) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.GroupMember
 */
const GroupMember = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.GroupMember",
  () => [
    { no: 1, name: "user", kind: "message", T: MemberUser },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(MemberRole) },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(RoomState) },
    { no: 4, name: "is_interactable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.chat.entity.v2.MemberUserData
 */
const MemberUserData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.MemberUserData",
  () => [
    { no: 1, name: "member_info", kind: "message", T: MemberUser },
    { no: 2, name: "is_group_member", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.chat.entity.v2.MemberStats
 */
const MemberStats = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.MemberStats",
  () => [
    { no: 1, name: "capacity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "current", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "available", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "active", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.chat.entity.v2.AdminStats
 */
const AdminStats = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.AdminStats",
  () => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/message_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/message.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck







/**
 * @generated from enum social.chat.entity.v2.MessageBodyType
 */
const MessageBodyType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MessageBodyType",
  [
    {no: 0, name: "MESSAGE_BODY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MESSAGE_BODY_TYPE_CONVERSATION", localName: "CONVERSATION"},
    {no: 2, name: "MESSAGE_BODY_TYPE_EVENT", localName: "EVENT"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.MessageStatus
 */
const MessageStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MessageStatus",
  [
    {no: 0, name: "MESSAGE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MESSAGE_STATUS_SENT", localName: "SENT"},
    {no: 2, name: "MESSAGE_STATUS_READ", localName: "READ"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.CursorDirection
 */
const CursorDirection = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.CursorDirection",
  [
    {no: 0, name: "CURSOR_DIRECTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CURSOR_DIRECTION_IN_FRONT", localName: "IN_FRONT"},
    {no: 2, name: "CURSOR_DIRECTION_BEHIND", localName: "BEHIND"},
    {no: 3, name: "CURSOR_DIRECTION_BETWEEN", localName: "BETWEEN"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.Message
 */
const Message = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.Message",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "body_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(MessageBodyType) },
    { no: 3, name: "body", kind: "message", T: MessageBody },
    { no: 4, name: "created_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageBody
 */
const MessageBody = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageBody",
  () => [
    { no: 1, name: "conversation", kind: "message", T: MessageConversation, oneof: "body" },
    { no: 2, name: "event", kind: "message", T: MessageEvent, oneof: "body" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageEvent
 */
const MessageEvent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageEvent",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "format", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(TextFormat) },
    { no: 3, name: "placeholder_mask", kind: "message", T: PlaceholderMaskedText },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageConversation
 */
const MessageConversation = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageConversation",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masked_text", kind: "message", T: MaskedText },
    { no: 3, name: "content", kind: "message", T: MessageContent },
    { no: 4, name: "sender", kind: "message", T: MessageSender },
    { no: 5, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(MessageStatus) },
    { no: 6, name: "flag", kind: "message", T: MessageFlag },
    { no: 7, name: "replied_message", kind: "message", T: Message },
    { no: 8, name: "attachment_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(AttachmentType) },
    { no: 9, name: "attachment", kind: "message", T: AttachmentV2 },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageFlag
 */
const MessageFlag = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageFlag",
  () => [
    { no: 1, name: "is_reply", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_forwarded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_time_displayed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageSender
 */
const MessageSender = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageSender",
  () => [
    { no: 1, name: "user", kind: "message", T: MemberUser },
    { no: 2, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "displayed_as", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(MessageSender_DisplayedAs) },
    { no: 4, name: "is_active_member", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.MessageSender.DisplayedAs
 */
const MessageSender_DisplayedAs = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MessageSender.DisplayedAs",
  [
    {no: 0, name: "DISPLAYED_AS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DISPLAYED_AS_SENDER", localName: "SENDER"},
    {no: 2, name: "DISPLAYED_AS_RECEIVER", localName: "RECEIVER"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageContent
 */
const MessageContent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageContent",
  () => [
    { no: 1, name: "attachment", kind: "message", T: Attachment },
    { no: 2, name: "shared_content", kind: "message", T: SharedContentPreview },
    { no: 3, name: "replied_message", kind: "message", T: Message },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/chat/v1/message_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/chat/v1/message.proto (package social.wssocial.entity.wsevent.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedMessage
 */
const ReceivedMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedMessage",
  () => [
    { no: 1, name: "v1", kind: "message", T: ReceivedMessageV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1
 */
const ReceivedMessageV1 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1",
  () => [
    { no: 1, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "room", kind: "message", T: BaseRoom },
    { no: 3, name: "room_status", kind: "message", T: ReceivedMessageV1_RoomStatus },
    { no: 4, name: "message", kind: "message", T: Message },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1.RoomStatus
 */
const ReceivedMessageV1_RoomStatus = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1.RoomStatus",
  () => [
    { no: 1, name: "is_muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_mentioned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReceivedMessageV1_RoomStatus"},
);


// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/chat/v1/typing_indicator_pb.js
var typing_indicator_pb = __webpack_require__(1835);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/chat/v1/room_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/chat/v1/room.proto (package social.wssocial.entity.wsevent.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfo
 */
const ReceivedRoomInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfo",
  () => [
    { no: 1, name: "v1", kind: "message", T: ReceivedRoomInfoV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfoV1
 */
const ReceivedRoomInfoV1 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfoV1",
  () => [
    { no: 1, name: "room", kind: "message", T: Room },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/stream/v1/post_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/stream/v1/post.proto (package social.wssocial.entity.wsevent.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.wssocial.entity.wsevent.stream.v1.ReceivedPost
 */
const ReceivedPost = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.stream.v1.ReceivedPost",
  () => [
    { no: 1, name: "v1", kind: "message", T: ReceivedPostV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.stream.v1.ReceivedPostV1
 */
const ReceivedPostV1 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.stream.v1.ReceivedPostV1",
  () => [
    { no: 1, name: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/research/v1/post_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/research/v1/post.proto (package social.wssocial.entity.wsevent.research.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.wssocial.entity.wsevent.research.v1.ReceivedPost
 */
const post_pb_ReceivedPost = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.research.v1.ReceivedPost",
  () => [
    { no: 1, name: "v1", kind: "message", T: post_pb_ReceivedPostV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.research.v1.ReceivedPostV1
 */
const post_pb_ReceivedPostV1 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.research.v1.ReceivedPostV1",
  () => [
    { no: 1, name: "research_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/message/v1/received_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/received.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck









/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedMessage
 */
const received_pb_ReceivedMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedMessage",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ReceivedMessage_Type) },
    { no: 2, name: "body", kind: "message", T: Body },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ReceivedMessage.Type
 */
const ReceivedMessage_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.ReceivedMessage.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_PING", localName: "PING"},
    {no: 2, name: "TYPE_SUBSCRIBE", localName: "SUBSCRIBE"},
    {no: 3, name: "TYPE_UNSUBSCRIBE", localName: "UNSUBSCRIBE"},
    {no: 4, name: "TYPE_BROADCAST", localName: "BROADCAST"},
    {no: 5, name: "TYPE_ERROR", localName: "ERROR"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Body
 */
const Body = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Body",
  () => [
    { no: 1, name: "ping", kind: "message", T: Ping, oneof: "body" },
    { no: 2, name: "subscription", kind: "message", T: Subscription, oneof: "body" },
    { no: 3, name: "event", kind: "message", T: ReceivedEvent, oneof: "body" },
    { no: 4, name: "error", kind: "message", T: Error, oneof: "body" },
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Ping
 */
const Ping = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Ping",
  () => [
    { no: 1, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Ping_PingStatus) },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.Ping.PingStatus
 */
const Ping_PingStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.Ping.PingStatus",
  [
    {no: 0, name: "PING_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PING_STATUS_OK", localName: "OK"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Subscription
 */
const Subscription = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Subscription",
  () => [
    { no: 1, name: "channel", kind: "message", T: base_pb/* Channel */.$W },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Subscription_Status) },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.Subscription.Status
 */
const Subscription_Status = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.Subscription.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_SUBSCRIBED", localName: "SUBSCRIBED"},
    {no: 2, name: "STATUS_UNSUBSCRIBED", localName: "UNSUBSCRIBED"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedEvent
 */
const ReceivedEvent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedEvent",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ReceivedEvent_Type) },
    { no: 2, name: "data", kind: "message", T: ReceivedEvent_Data },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ReceivedEvent.Type
 */
const ReceivedEvent_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.ReceivedEvent.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_CHAT_MESSAGE", localName: "CHAT_MESSAGE"},
    {no: 2, name: "TYPE_CHAT_TYPING_INDICATOR", localName: "CHAT_TYPING_INDICATOR"},
    {no: 3, name: "TYPE_CHAT_ROOM_INFO", localName: "CHAT_ROOM_INFO"},
    {no: 4, name: "TYPE_STREAM", localName: "STREAM"},
    {no: 5, name: "TYPE_RESEARCH", localName: "RESEARCH"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedEvent.Data
 */
const ReceivedEvent_Data = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedEvent.Data",
  () => [
    { no: 1, name: "chat_message", kind: "message", T: ReceivedMessage, oneof: "data" },
    { no: 2, name: "chat_typing_indicator", kind: "message", T: typing_indicator_pb/* ReceivedTypingIndicator */.$B, oneof: "data" },
    { no: 3, name: "chat_room_info", kind: "message", T: ReceivedRoomInfo, oneof: "data" },
    { no: 4, name: "stream", kind: "message", T: ReceivedPost, oneof: "data" },
    { no: 5, name: "research", kind: "message", T: post_pb_ReceivedPost, oneof: "data" },
  ],
  {localName: "ReceivedEvent_Data"},
);

/**
 * @generated from message social.wssocial.entity.message.v1.Error
 */
const Error = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Error",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);



/***/ }),

/***/ 79278:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uz": function() { return /* binding */ SendMessage; }
/* harmony export */ });
/* unused harmony exports SendMessage_Type, Payload, SendEvent, SendEvent_Type, SendEvent_Data */
/* harmony import */ var _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7722);
/* harmony import */ var _base_pb_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88244);
/* harmony import */ var _wsevent_chat_v1_typing_indicator_pb_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1835);
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/send.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from message social.wssocial.entity.message.v1.SendMessage
 */
const SendMessage = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.SendMessage",
  () => [
    { no: 1, name: "type", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.getEnumType */ .w.getEnumType(SendMessage_Type) },
    { no: 2, name: "payload", kind: "message", T: Payload },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.SendMessage.Type
 */
const SendMessage_Type = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.makeEnum */ .w.makeEnum(
  "social.wssocial.entity.message.v1.SendMessage.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_PING", localName: "PING"},
    {no: 2, name: "TYPE_SUBSCRIBE", localName: "SUBSCRIBE"},
    {no: 3, name: "TYPE_UNSUBSCRIBE", localName: "UNSUBSCRIBE"},
    {no: 4, name: "TYPE_BROADCAST", localName: "BROADCAST"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Payload
 */
const Payload = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.Payload",
  () => [
    { no: 1, name: "channel", kind: "message", T: _base_pb_js__WEBPACK_IMPORTED_MODULE_0__/* .Channel */ .$W, oneof: "payload" },
    { no: 2, name: "event", kind: "message", T: SendEvent, oneof: "payload" },
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.SendEvent
 */
const SendEvent = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.SendEvent",
  () => [
    { no: 1, name: "type", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.getEnumType */ .w.getEnumType(SendEvent_Type) },
    { no: 2, name: "data", kind: "message", T: SendEvent_Data },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.SendEvent.Type
 */
const SendEvent_Type = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.makeEnum */ .w.makeEnum(
  "social.wssocial.entity.message.v1.SendEvent.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_CHAT_TYPING_INDICATOR", localName: "CHAT_TYPING_INDICATOR"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.SendEvent.Data
 */
const SendEvent_Data = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_2__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.SendEvent.Data",
  () => [
    { no: 1, name: "chat_typing_indicator", kind: "message", T: _wsevent_chat_v1_typing_indicator_pb_js__WEBPACK_IMPORTED_MODULE_1__/* .SendTypingIndicator */ .w0, oneof: "data" },
  ],
  {localName: "SendEvent_Data"},
);



/***/ }),

/***/ 1835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ ReceivedTypingIndicator; },
/* harmony export */   "w0": function() { return /* binding */ SendTypingIndicator; }
/* harmony export */ });
/* unused harmony exports ReceivedTypingIndicatorV1, ReceivedTypingIndicatorV1_UserTypingInfo */
/* harmony import */ var _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7722);
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/chat/v1/typing_indicator.proto (package social.wssocial.entity.wsevent.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.SendTypingIndicator
 */
const SendTypingIndicator = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.SendTypingIndicator",
  () => [
    { no: 1, name: "room_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "is_typing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicator
 */
const ReceivedTypingIndicator = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicator",
  () => [
    { no: 2, name: "v1", kind: "message", T: ReceivedTypingIndicatorV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1
 */
const ReceivedTypingIndicatorV1 = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1",
  () => [
    { no: 1, name: "room_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "user", kind: "message", T: ReceivedTypingIndicatorV1_UserTypingInfo },
    { no: 3, name: "is_typing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1.UserTypingInfo
 */
const ReceivedTypingIndicatorV1_UserTypingInfo = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1.UserTypingInfo",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "ReceivedTypingIndicatorV1_UserTypingInfo"},
);



/***/ })

}]);